export enum ChannelStatus {
    Active = 'active',
    Inactive = 'inactive',
}
